NP.MsgPreview = ( function( $ ) {
	var $el = $( '<div class="stickerPreview">' ),
		$msg = $( '<div class="wrapSticker">' ),
		$wrap = $( '<div class="sticker">' ),
		$deleteButton = $( '<a class="btnDelete">삭제</a>' ),
		_msg = '';

	// 초기화
	function init() {
		eventBinding();
	}

	// 마크업 생성
	function render( data ) {

		var $sticker = $( '<img src="' + data.animation.replace( /^ncms:\/\//, 'https://' ).replace( /^ncm:\/\//, 'http://' ).replace(/thumb.png/, 'sticker.gif' ) + '" alt="{{' + data.name + '}}" height="102">' );
		
		_msg = data.name;
		
		$wrap.html( $deleteButton ).append( $sticker );
		$msg.append( $wrap );
		$el.append( $msg );
		$el.show();
		return $el;
	}

	// 이벤트 바인딩
	function eventBinding() {
		// 스티커 미리보기 삭제
		$el.on( 'click', '.btnDelete', function( e ) {
			e.stopPropagation();
			hide();
		});
	}

	// 메시지 미리보기 감추기
	function hide() {
		$el.hide();
	}
	
	// 메시지 미리보기 보이기
	function show() {
		$el.show();
	}
	
	// 데이터 리턴
	function getSticker() {
		return ( $el.is( ':visible' ) )? _msg: '';
	}

	// API
	return {
		init : init,
		render : render,
		hide : hide,
		show : show,
		getSticker: getSticker
	};
}( jQuery ));
